export default "__VITE_ASSET__BuUTZngV__"